import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'

interface AccountingTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
  hasExpCats?: boolean
}

const AccountingTooltip: React.FC<AccountingTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        {translate(
          props.hasExpCats
            ? 'Accounting data is used to track spending and reconcile expenses. This data includes Expense Categories to organize transactions, and attachments, such as receipts or invoices.'
            : 'Accounting data is used to track spending and reconcile expenses. This data includes attachments, such as receipts or invoices.',
        )}
      </p>
    </Tooltip>
  )
}

export default AccountingTooltip
